import { usePwaUpdate } from "@/lib/PwaUpdateContext";
import { RefreshCw, X } from "lucide-react";
import { useState } from "react";

export default function UpdatePrompt() {
  const { updateReady, dismissed, blocked, applyUpdate, dismiss } = usePwaUpdate();
  const [busy, setBusy] = useState(false);
  if (!updateReady || dismissed) return null;

  const onUpdate = async () => { setBusy(true); try { await applyUpdate(); } finally { setBusy(false); } };

  return (
    <div
      data-testid="pwa-update-prompt"
      className="fixed z-[120] bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm bg-[#1E1B4B] text-white border-2 border-[#14B8A6] shadow-2xl"
    >
      <div className="p-4">
        <div className="flex items-start gap-3">
          <RefreshCw size={18} className="text-[#14B8A6] mt-0.5 shrink-0" strokeWidth={2.5} />
          <div className="min-w-0">
            <p className="font-black text-sm">A new version of Compliance Hub is ready.</p>
            {blocked ? (
              <p className="text-xs text-amber-300 mt-1" data-testid="pwa-update-blocked">
                We couldn&apos;t confirm your current work was saved, so the update is paused. Check your connection and retry — your work stays on this device.
              </p>
            ) : (
              <p className="text-xs text-slate-300 mt-1">Your current work is saved before updating. Updating takes a moment.</p>
            )}
          </div>
          <button onClick={dismiss} data-testid="pwa-update-later-x" className="p-1 text-slate-400 hover:text-white shrink-0" aria-label="Dismiss">
            <X size={16} />
          </button>
        </div>
        <div className="flex gap-2 mt-3">
          <button
            onClick={onUpdate}
            disabled={busy}
            data-testid="pwa-update-now"
            className="flex-1 h-10 inline-flex items-center justify-center gap-2 bg-[#14B8A6] text-[#0F0E2E] font-bold text-xs uppercase tracking-wider hover:bg-[#0D9488] disabled:opacity-60"
          >
            {busy ? "Saving & updating…" : (blocked ? "Retry update" : "Update now")}
          </button>
          <button
            onClick={dismiss}
            disabled={busy}
            data-testid="pwa-update-later"
            className="h-10 px-4 border-2 border-white/30 text-white font-bold text-xs uppercase tracking-wider hover:border-white"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  );
}
